import { useCallback, useEffect, useState } from 'react'
import { Table, Button, Modal, Form } from 'react-bootstrap'
import apinode from '../../../services/apinode'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { toast } from 'react-toastify'
import { CustomButton } from '../../../components/CustomButton'
import { formatDate } from '../../../utils/formatDate'
import { X } from '@phosphor-icons/react'
import { NoteBlank } from 'phosphor-react'
import { gerarRelatorioUltimosDias } from '../../../utils/relatorios/relatorioUltimosDias'

export function ModalContagem({ isOpen, onClose, selectedInventoryId }) {
  const [data, setData] = useState([])
  const [daysOfSales, setDaysOfSales] = useState('')
  const [isProductsLoading, setIsProductsLoading] = useState(false)
  const [productsSelected, setProductsSelected] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleGetCount = useCallback(async () => {
    try {
      const response = await apinode.get(
        `inventario/listarcoletas/${localStorage.idconta}/${selectedInventoryId}`,
      )

      setData(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar dados da contagem!')
    }
  }, [selectedInventoryId])

  async function fetchRelatorio90dias() {
    setIsProductsLoading(true)

    try {
      const response = await apinode.post(
        `/relatorios/90dias/${localStorage.idconta}`,
        { skus: productsSelected, daysOfSales },
      )

      setIsModalOpen(false)
      gerarRelatorioUltimosDias(daysOfSales, response.data)
    } catch (error) {
      toast.error('Erro ao buscar produtos, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  useEffect(() => {
    handleGetCount()
  }, [handleGetCount])

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header
          className="custom-modal-header"
          style={{
            background: '#fff',
          }}
        >
          <Modal.Title
            style={{
              color: '#000',
            }}
          >
            Registros
          </Modal.Title>

          <CustomButton
            onClick={() => setIsModalOpen(true)}
            isDisabled={productsSelected.length === 0}
          >
            <NoteBlank size={25} />
            Gerar Relatório
          </CustomButton>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px', overflow: 'auto' }}>
          {data.length > 0 ? (
            <Table
              striped
              bordered
              hover
              responsive
              className="custom-table nowrap"
            >
              <thead>
                <th
                  className="small"
                  style={{ width: '50px', color: 'black' }}
                >
                  <Form.Check
                    checked={productsSelected.length === data.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setProductsSelected(data.map((item) => item.SKU))
                      } else {
                        setProductsSelected([])
                      }
                    }}
                  />
                </th>
                <th style={{ width: '50px', color: 'black' }}>#</th>
                <th style={{ width: '50px', color: 'black' }}>ID</th>
                <th style={{ width: '50px', color: 'black' }}>SKU</th>
                <th style={{ width: '200px', color: 'black' }}>Descrição</th>
                <th style={{ width: '50px', color: 'black' }}>Qtd Contagem</th>
                <th style={{ width: '50px', color: 'black' }}>Qtd Estoque</th>
                <th style={{ width: '50px', color: 'black' }}>Contagem </th>
                <th style={{ width: '50px', color: 'black' }}>Data e Hora</th>
                <th style={{ width: '50px', color: 'black' }}>ID do Usuário</th>
                <th style={{ width: '50px', color: 'black' }}>Funcionário</th>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="small">
                      <Form.Check
                        checked={productsSelected.includes(item.SKU)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setProductsSelected((prevState) => [
                              ...prevState,
                              item.SKU,
                            ])
                          } else {
                            setProductsSelected((prevState) =>
                              prevState.filter((prod) => prod !== item.SKU),
                            )
                          }
                        }}
                      />
                    </td>
                    <td className="small">{index + 1}</td>
                    <td className="small">{item.ID}</td>
                    <td className="small">{item.SKU}</td>
                    <td
                      className="small"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      {item.DESCRICAO}
                    </td>
                    <td className="small">{item.QTDCONT}</td>
                    <td className="small">{item.QTESTGER}</td>
                    <td className="small">{item.NUMCONTAGEM}</td>
                    <td className="small">
                      {formatDate(item.DATAHORA, "dd/MM/yyyy 'às' HH:mm")}
                    </td>
                    <td className="small">{item.IDUSER}</td>
                    <td className="small">{item.NOMEFUNCIONARIO}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>Sem dados disponíveis!</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onClose}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
      >
        <Modal.Header>
          <Modal.Title>Dias de Venda</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Control
            type="text"
            value={daysOfSales}
            onChange={(e) => setDaysOfSales(e.target.value)}
            placeholder="Digite aqui..."
          />
        </Modal.Body>

        <Modal.Footer>
          <CustomButton
            onClick={() => setIsModalOpen(false)}
            title="Fechar"
            color="#6c757d"
          >
            <X size={25} />
          </CustomButton>

          <CustomButton
            onClick={fetchRelatorio90dias}
            isLoading={isProductsLoading}
            isLoadingText="Gerando..."
            title="Gerar"
          >
            <NoteBlank size={25} />
          </CustomButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}
